import { render } from "./TabsContentPage.vue?vue&type=template&id=342a162e&scoped=true"
import script from "./TabsContentPage.vue?vue&type=script&lang=js"
export * from "./TabsContentPage.vue?vue&type=script&lang=js"

import "./TabsContentPage.vue?vue&type=style&index=0&id=342a162e&scoped=true&lang=scss"

import exportComponent from "/home/forge/mooz360.co.il/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-342a162e"]])

export default __exports__